/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../reports.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import { withTranslation } from "react-i18next";
import Input from "../../../../component/inputpm";
import {
  SearchIcon,
  ClearIcon,
  ReturnIcon,
} from "../../../../component/icons/icons";
import { Tooltip, IconButton } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Collapse from "@mui/material/Collapse";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../../../helper/numberFormatter";

const AssetOwnershipTable = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const mainStyle = {
    maxWidth: "auto",
    margin: "auto",
    padding: "auto",
    paddingTop: "0",
    paddingRight: "0",
    backgroundColor: "transparent",
  };
  return (
    <div>
      <div className={classes.root}>
        {/* <h3 style={{ marginTop: 0 }}>{t('ASSET')}: {props.isChild ? props.childItemDetails.partyName : props.customerDetails.accountName}</h3> */}
        {/* <Paper className={'tablePaper'}> */}
        <div style={{ display: "flex", flexDirection: "column", width: "95%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <span style={{ bottom: "0", position: "relative" }}>
              <h3 style={{}}>
                {t("ASSET")}:{" "}
                {props.isChild
                  ? props.childItemDetails.partyName
                  : props.customerDetails.accountName}
              </h3>
            </span>
            <div
              className={classes.searchOuterDiv}
              style={{ flexWrap: "wrap", alignContent: "end" }}
            >
              <div className={classes.searchInputDiv}>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("SERIAL_NUMBER")}
                  value={props.serialNumber}
                  name={"serialNumber"}
                  onChange={(e) => {
                    props.changeSearialNumber(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onAssetSearchKeyDown(e);
                  }}
                />
              </div>
              {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={props.searchAssetData}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={props.clearAssetDataSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
              {/* <div className="cl"></div> */}
            </div>
          </div>
          {props.listProxy.length === 0 && (
            <Box
              className="roundCorners"
              style={{ border: "1px solid lightgrey", padding: "1.5rem" }}
            >
              <Grid container spacing={2} align="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  {t("NO_DATA_FOUND")}
                </Grid>
              </Grid>
            </Box>
          )}
          {props.listProxy.length > 0 && (
            <Box
              className="roundCorners"
              style={{ border: "1px solid lightgrey", marginTop: "1rem" }}
            >
              <TableContainer>
                <Table
                  className={classes.table + " " + "newGlobalTable"}
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <div style={{ width: "7%", display: "inline" }}>
                          &nbsp;
                        </div>
                        <b>{t("NAME")}</b>
                      </TableCell>
                      <TableCell>
                        <b>{t("SERIAL_NO")}</b>
                      </TableCell>
                      <TableCell>
                        <b>{t("ACTION")}</b>
                      </TableCell>
                      {/* <TableCell>
                                            <Grid container>
                                                <Grid item xs={6}>
                                                    <div style={{ width: '7%', display: 'inline' }}>
                                                        &nbsp;
                                                    </div>
                                                    <b>{t('NAME')}</b>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <b>{t('SERIAL_NO')}</b>
                                                </Grid>
                                                <Grid item xs={1} align={'center'}>
                                                    <b>{t('ACTION')}</b>
                                                </Grid>
                                            </Grid>
                                        </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Show orders list */}
                    {props.listProxy.map((row, index) => (
                      <>
                        <TableRow key={index}>
                          {row != null && (
                            <>
                              <TableCell>
                                <div style={{ width: "7%", float: "left" }}>
                                  {row.assembly && (
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={() => props.openAssetData(index)}
                                    >
                                      {row.expand ? (
                                        <KeyboardArrowUpIcon />
                                      ) : (
                                        <KeyboardArrowDownIcon />
                                      )}
                                    </IconButton>
                                  )}
                                </div>
                                <div style={{ float: "left", width: "93%" }}>
                                  {row.productName}
                                </div>
                                <div style={{ clear: "both" }}></div>
                              </TableCell>
                              <TableCell>{row.serialNumber}</TableCell>
                              <TableCell>
                                {row.itemReturned ? (
                                  <>
                                    <Tooltip title={t("VIEW_RETURN")}>
                                      <IconButton
                                        onClick={() => {
                                          navigate(`/return/${row.orderId}`);
                                        }}
                                      >
                                        <Visibility />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                ) : (
                                  <>
                                    <Tooltip title={t("RETURN")}>
                                      <IconButton
                                        onClick={() => {
                                          navigate(`/return/${row.orderId}`);
                                        }}
                                      >
                                        <ReturnIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </TableCell>
                              {/* <TableCell>
                                                                <Grid container>
                                                                    <Grid item xs={6} style={{ whiteSpace: 'break-spaces', wordWrap: 'break-word' }}>
                                                                        <div style={{ width: '7%', float: 'left' }}>
                                                                            {row.assembly &&
                                                                                <IconButton aria-label="expand row" size="small" onClick={() => props.openAssetData(index)} >
                                                                                    {row.expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                                </IconButton>
                                                                            }
                                                                        </div>
                                                                        <div style={{ float: 'left', width: '93%' }}>
                                                                            {row.productName}
                                                                        </div>
                                                                        <div style={{ clear: 'both' }}></div>
                                                                    </Grid>
                                                                    <Grid item xs={5} style={{ whiteSpace: 'break-spaces', wordWrap: 'break-word' }}>
                                                                        {row.serialNumber}
                                                                    </Grid>
                                                                    <Grid item xs={1} align={'center'}>
                                                                        {row.itemReturned ?
                                                                            <>

                                                                                <Tooltip title={t('VIEW_RETURN')}>
                                                                                    <IconButton onClick={() => {
                                                                                        navigate(`/return/${row.orderId}`)
                                                                                    }}>
                                                                                        <Visibility />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <Tooltip title={t('RETURN')}>
                                                                                    <IconButton onClick={() => {
                                                                                        navigate(`/return/${row.orderId}`)
                                                                                    }}>
                                                                                        <ReturnIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </>

                                                                        }
                                                                    </Grid>
                                                                </Grid>
                                                            </TableCell> */}
                            </>
                          )}
                          {/* <TableCell>{row.orderId}</TableCell> */}
                        </TableRow>
                        {row.childProducts && row.childProducts.length > 0 && (
                          <TableRow>
                            <TableCell
                              className={"subscriptionTableCustomeCollapseCell"}
                            >
                              <Collapse
                                in={row.expand}
                                timeout="auto"
                                style={{}}
                              >
                                <LineItem {...row} />
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    ))}
                    {/* If there is no orders to show */}
                    {/* {props.listProxy.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={12} align="center">
                                                    {t("NO_DATA_FOUND")}
                                                </TableCell>
                                            </TableRow>
                                        )} */}
                  </TableBody>
                </Table>
              </TableContainer>
              {props.totalAssetCount > 0 && (
                <div
                  className="global-custom-pagination"
                  style={{ background: "rgba(196, 196, 196, 0.2)" }}
                >
                  <label style={{ float: "left", padding: "5px" }}>
                    {t("TOTAL_RECORDS")}: {formatNumber(props.totalAssetCount)}
                  </label>
                  <label>
                    {t("ROWS_PER_PAGE")}
                    <Select
                      value={props.assetDataPerpage}
                      onChange={props.assetDataRowsPerPageChange}
                    >
                      <MenuItem
                        value={10}
                        classes={{ root: "treeRowPerPageItem" }}
                      >
                        10
                      </MenuItem>
                      <MenuItem
                        value={50}
                        classes={{ root: "treeRowPerPageItem" }}
                      >
                        50
                      </MenuItem>
                      <MenuItem
                        value={100}
                        classes={{ root: "treeRowPerPageItem" }}
                      >
                        100
                      </MenuItem>
                    </Select>
                  </label>
                  <Pagination
                    count={Math.ceil(
                      props.totalAssetCount / props.assetDataPerpage,
                    )}
                    onChange={props.assetDataPageChange}
                    page={props.assetDataPage}
                    showFirstButton
                    showLastButton
                  />
                </div>
              )}
              {/* </Paper> */}
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

const LineItem = (row) => {
  return (
    <TableContainer>
      <Table style={{ maxWidth: "100%", border: 0 }}>
        <TableBody>
          {row.childProducts &&
            row.childProducts.map((item, cIndex) => (
              <>
                <TableRow key={cIndex}>
                  <TableCell
                    className={"subscriptionTableCustomeCollapseCell"}
                    style={{ borderLeft: 0, borderRight: 0 }}
                  >
                    <Grid container className="assetCustomColumn">
                      <Grid
                        item
                        size={{
                          xs: 6,
                        }}
                      >
                        <div style={{ paddingLeft: item.level * 25 + 25 }}>
                          {item.internalName}
                        </div>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 5,
                        }}
                      >
                        {item.serialNumber}
                      </Grid>
                      <Grid
                        item
                        align={"center"}
                        size={{
                          xs: 1,
                        }}
                      >
                        &nbsp;
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
                {/* {item.childProducts && item.childProducts.length > 0 &&
                            <TableRow>
                                <TableCell className={'subscriptionTableCustomeCollapseCell'} style={{ borderLeft: 0, borderRight: 0 }}>
                                    <LineItem {...item} />
                                </TableCell>
                            </TableRow>
                        } */}
              </>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default withTranslation("translations")(AssetOwnershipTable);
